import { render, staticRenderFns } from "./AssignmentDocumentsReport.vue?vue&type=template&id=a99f75be"
import script from "./AssignmentDocumentsReport.vue?vue&type=script&lang=js"
export * from "./AssignmentDocumentsReport.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDocumentsReport.vue?vue&type=style&index=0&id=a99f75be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports